
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "loginNewGoogleUser",
      resolverType: "mutation",
      routePath: "/loginNewGoogleUser",
      httpMethod: "POST",
    });
  